import { useSetFilter } from '../../filter';
import { WorkspaceOrderKey } from '../domain';

export const useSetWorkspaceListOrder = () => {
  return useSetFilter(WorkspaceOrderKey, 'workspaceOrderBy');
};
